export const formatCurrency = (
  v: number | unknown,
  floor?: boolean
): string | null => {
  if (typeof v !== "number") {
    return null;
  }
  if (isNaN(v)) {
    return null;
  }
  const value: number = floor ? floorPence(v) : v;

  return value.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 2,
  });
};

export const floorPence = (v: number): number => {
  if (v < 0) {
    return Math.ceil(v * 100) / 100;
  }
  return Math.floor(v * 100) / 100;
};
